import { actionCreator } from '@ardoq/rxbeach';

export const loggedOut = actionCreator('[auth] USER_LOGGED_OUT');
